import { until1jbpn0z3f8lbg as until } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  Char__rangeTo_impl_tkncvp2ayilkxhavi41 as Char__rangeTo_impl_tkncvp,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { plus39kp8wyage607 as plus } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  freeze2t025y794sude as freeze,
  getRandomUuidBytes3aykfxcg1y7rs as getRandomUuidBytes,
} from './platform.mjs';
import { charArray2ujmm1qusno00 as charArray } from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { concatToString2syawgu50khxi as concatToString } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import {
  contentEquals1cdp6c846cfdi as contentEquals,
  contentHashCode25jw6rgkgywwr as contentHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { toByte4i43936u611k as toByte } from '../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var UUID_CHAR_RANGES;
var UUID_HYPHEN_INDICES;
function get_UUID_CHARS() {
  _init_properties_uuid_kt__7swked();
  return UUID_CHARS;
}
var UUID_CHARS;
var properties_initialized_uuid_kt_pyvynx;
function _init_properties_uuid_kt__7swked() {
  if (!properties_initialized_uuid_kt_pyvynx) {
    properties_initialized_uuid_kt_pyvynx = true;
    UUID_CHAR_RANGES = listOf([until(0, 8), until(9, 13), until(14, 18), until(19, 23), until(24, 36)]);
    UUID_HYPHEN_INDICES = listOf([8, 13, 18, 23]);
    UUID_CHARS = plus(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57)), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(102)));
  }
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.m40_1 = listOf([until(0, 4), until(4, 6), until(6, 8), until(8, 10), until(10, 16)]);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var UuidClass;
function Uuid() {
  if (UuidClass === VOID) {
    class $ {
      constructor(uuidBytes) {
        Companion_getInstance();
        this.n40_1 = uuidBytes;
        // Inline function 'kotlin.collections.count' call
        // Inline function 'kotlin.require' call
        if (!(this.n40_1.length === 16)) {
          // Inline function 'kotlin.collections.count' call
          var message = 'Invalid UUID bytes. Expected 16 bytes; found ' + this.n40_1.length;
          throw IllegalArgumentException().n2(toString(message));
        }
        freeze(this);
      }
      toString() {
        var characters = charArray(36);
        var charIndex = 0;
        var tmp0_iterator = Companion_getInstance().m40_1.p1();
        while (tmp0_iterator.q1()) {
          var range = tmp0_iterator.r1();
          var inductionVariable = range.q3_1;
          var last = range.r3_1;
          if (inductionVariable <= last)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var octetPair = this.n40_1[i];
              var left = octetPair >> 4 & 15;
              var right = octetPair & 15;
              var tmp2 = charIndex;
              charIndex = tmp2 + 1 | 0;
              characters[tmp2] = get_UUID_CHARS().r2(left).e4_1;
              var tmp3 = charIndex;
              charIndex = tmp3 + 1 | 0;
              characters[tmp3] = get_UUID_CHARS().r2(right).e4_1;
            }
             while (!(i === last));
          if (charIndex < 36) {
            var tmp4 = charIndex;
            charIndex = tmp4 + 1 | 0;
            characters[tmp4] = _Char___init__impl__6a9atx(45);
          }
        }
        return concatToString(characters);
      }
      equals(other) {
        var tmp;
        if (other instanceof Uuid()) {
          tmp = contentEquals(this.n40_1, other.n40_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return contentHashCode(this.n40_1);
      }
      o40(other) {
        var inductionVariable = 0;
        if (inductionVariable < 16)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var compareResult = compareTo(this.n40_1[i], other.n40_1[i]);
            if (!(compareResult === 0))
              return compareResult;
          }
           while (inductionVariable < 16);
        return 0;
      }
      d(other) {
        return this.o40(other instanceof Uuid() ? other : THROW_CCE());
      }
    }
    initMetadataForClass($, 'Uuid', VOID, VOID, [Comparable()]);
    UuidClass = $;
  }
  return UuidClass;
}
function uuid4() {
  // Inline function 'com.benasher44.uuid.setVersion' call
  // Inline function 'kotlin.apply' call
  var this_0 = getRandomUuidBytes();
  this_0[6] = toByte(this_0[6] & 15 | 4 << 4);
  this_0[8] = toByte(this_0[8] & 63 | 128);
  return new (Uuid())(this_0);
}
//region block: exports
export {
  uuid4 as uuid4al7pp0fcb8o5,
};
//endregion

//# sourceMappingURL=uuid.mjs.map
